import {Api} from '../../../Api.js'

const RESOURCE = 'queue'

export default {
    resource: RESOURCE,
    prefix: '',
    all(query) {
        return Api().get(this.prefix + this.resource + '/all'  + (query ? query : '') )
    },
    query(query) {
        return Api().get(this.prefix + this.resource + (query ? query : ''))
    },
    get(id) {
        return Api().get(this.prefix + this.resource + '/' + id)
    }
}


// WEBPACK FOOTER //
// ./src/modules/config/queue/QueueService.js